// src/pages/Contacts/index.js (versão corrigida)
import React, {
  useState,
  useEffect,
  useReducer,
  useContext,
  useRef,
} from "react";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Button from "@material-ui/core/Button";
import Avatar from "@material-ui/core/Avatar";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Facebook, Instagram, WhatsApp, Close } from "@material-ui/icons";
import SearchIcon from "@material-ui/icons/Search";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import SendIcon from "@material-ui/icons/Send";
import CreateGroupCampaignModal from "../../components/CreateGroupCampaignModal";
import StandardTabs from "../../components/StandardTabs";
import EditIcon from "@material-ui/icons/Edit";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import BlockIcon from "@material-ui/icons/Block";
import PersonIcon from "@material-ui/icons/Person";
import GroupIcon from "@material-ui/icons/Group";
import PeopleAltIcon from "@material-ui/icons/PeopleAlt";
import Checkbox from "@material-ui/core/Checkbox";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Tooltip from "@material-ui/core/Tooltip";
import { alpha } from "@material-ui/core/styles";

import api from "../../services/api";
import TableRowSkeleton from "../../components/TableRowSkeleton";
import ContactModal from "../../components/ContactModal";
import ConfirmationModal from "../../components/ConfirmationModal/";
import ContactDeleteConfirmModal from "../../components/ContactDeleteConfirmModal";

import { i18n } from "../../translate/i18n";
import useWhatsApps from "../../hooks/useWhatsApps";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import MainContainer from "../../components/MainContainer";
import toastError from "../../errors/toastError";
import PageHelpGuide from "../../components/PageHelpGuide";
import { CONTACTS_HELP_DATA } from "../../constants/pageHelp/contactsHelp";
import { getStandardButtonStyles } from "../../styles/standardButtons";

import { AuthContext } from "../../context/Auth/AuthContext";
import { Can } from "../../components/Can";
import NewTicketModal from "../../components/NewTicketModal";
import { TagsFilter } from "../../components/TagsFilter";
import formatSerializedId from "../../utils/formatSerializedId";
import { v4 as uuidv4 } from "uuid";

import { GetApp } from "@material-ui/icons";
import { MenuItem, FormControl, Select } from "@material-ui/core";
import { TagsKanbanFilter } from "../../components/TagsKanbanFilter";

import ContactImportWpModal from "../../components/ContactImportWpModal";
import ConnectionIcon from "../../components/ConnectionIcon";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import { TicketsContext } from "../../context/Tickets/TicketsContext";

const reducer = (state, action) => {
  if (action.type === "LOAD_CONTACTS") {
    return Array.isArray(action.payload) ? action.payload : [];
  }

  if (action.type === "UPDATE_CONTACTS") {
    const contact = action.payload?.contact || action.payload;
    const currentTab = action.payload?.currentTab;
    const contactIndex = state.findIndex((c) => c.id === contact.id);

    const isGroup = Boolean(contact.isGroup);
    const matchesTab =
      !currentTab ||
      currentTab === "all" ||
      (currentTab === "groups" && isGroup) ||
      (currentTab === "contacts" && !isGroup);

    if (contactIndex !== -1) {
      if (!matchesTab) {
        return state.filter((c) => c.id !== contact.id);
      }
      state[contactIndex] = contact;
      return [...state];
    } else {
      if (!matchesTab) {
        return state;
      }
      return [contact, ...state];
    }
  }

  if (action.type === "DELETE_CONTACT") {
    const contactId = action.payload;
    const contactIndex = state.findIndex((c) => c.id === contactId);
    if (contactIndex !== -1) {
      state.splice(contactIndex, 1);
    }
    return [...state];
  }

  if (action.type === "BULK_DELETE_CONTACTS") {
    const contactIds = action.payload;
    return state.filter(contact => !contactIds.includes(contact.id));
  }

  if (action.type === "DELETE_ALL_CONTACTS") {
    const { excludeIds = [] } = action.payload;
    return state.filter(contact => excludeIds.includes(contact.id));
  }

  if (action.type === "RESET") {
    return [];
  }

  if (action.type === "SET_TOTAL_COUNT") {
    // Não altera o estado, mas permite rastrear o total
    return state;
  }
};

const useStyles = makeStyles((theme) => ({
  ...getStandardButtonStyles(theme),
  cyanButton: {
    backgroundColor: '#00b0ff !important',
    color: '#fff !important',
    borderRadius: '4px !important',
    textTransform: 'none !important',
    fontWeight: 'bold !important',
    transition: 'all 0.3s ease !important',
    '&:hover': {
      backgroundColor: '#0091ea !important',
      boxShadow: '0 4px 12px rgba(0, 176, 255, 0.4) !important',
      transform: 'translateY(-2px) !important'
    },
    '&:active': {
      transform: 'translateY(0) !important',
      boxShadow: 'none !important'
    }
  },
  greenButton: {
    backgroundColor: '#66bb6a !important',
    color: '#fff !important',
    borderRadius: '4px !important',
    textTransform: 'none !important',
    fontWeight: 'bold !important',
    transition: 'all 0.3s ease !important',
    marginRight: '10px !important',
    '&:hover': {
      backgroundColor: '#4caf50 !important',
      boxShadow: '0 4px 12px rgba(76, 175, 80, 0.4) !important',
      transform: 'translateY(-2px) !important'
    },
    '&:active': {
      transform: 'translateY(0) !important',
      boxShadow: 'none !important'
    }
  },
  tableHeader: {
    fontWeight: 'bold',
    backgroundColor: "#1e1e1e",
    color: "#fff",
    borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
  },
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    borderRadius: 16,
    backgroundColor: theme.palette.type === 'dark' ? '#2A2D32 !important' : theme.palette.background.paper,
  },
  actionButton: {
    transition: "transform 0.2s",
    "&:hover": {
      transform: "scale(1.2)",
    },
  },
  btnEdit: {
    color: "#00a8ff",
  },
  btnBlock: {
    color: "#fbc531",
  },
  btnCheck: {
    color: "#4cd137",
  },
  btnDelete: {
    color: "#e84118",
  },
  scrollArea: {
    flex: 1,
    overflowY: "scroll",
    ...theme.scrollbarStyles,
  },
  avatarCell: {
    width: '60px',
    padding: theme.spacing(1),
  },
  idCell: {
    width: '80px',
  },
  checkboxCell: {
    width: '48px',
    padding: theme.spacing(0, 1),
  },
  clickableAvatar: {
    cursor: 'pointer',
    transition: 'transform 0.2s ease-in-out',
    '&:hover': {
      transform: 'scale(1.1)',
    },
  },
  imageDialog: {
    '& .MuiDialog-paper': {
      maxWidth: '500px',
      maxHeight: '500px',
    },
  },
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: theme.spacing(1),
  },
  profileImage: {
    width: '100%',
    height: 'auto',
    maxWidth: '400px',
    maxHeight: '400px',
    objectFit: 'contain',
  },
  toolbar: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    backgroundColor: alpha(theme.palette.primary.main, 0.12),
    minHeight: 48,
  },
  toolbarHighlight: {
    backgroundColor: alpha(theme.palette.primary.main, 0.25),
  },
  toolbarTitle: {
    flex: '1 1 100%',
    fontWeight: 600,
  },
  bulkActions: {
    display: 'flex',
    gap: theme.spacing(1),
  },
}));

const Contacts = () => {
  const theme = useTheme();
  const isDarkMode = theme.mode === "dark" || theme.palette.type === "dark" || theme.palette.mode === "dark";
  const classes = useStyles();
  const history = useHistory();
  const { user, socket } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [searchParam, setSearchParam] = useState("");
  const [contacts, dispatch] = useReducer(reducer, []);
  const [selectedContactId, setSelectedContactId] = useState(null);
  const [contactModalOpen, setContactModalOpen] = useState(false);
  const [selectedKanbanTags, setSelectedKanbanTags] = useState([]);
  const [selectedKanbanLane, setSelectedKanbanLane] = useState("");
  const [selectedKanbanBoard, setSelectedKanbanBoard] = useState("");
  const [selectedBoardWhatsappIds, setSelectedBoardWhatsappIds] = useState([]);
  const [selectedWhatsapp, setSelectedWhatsapp] = useState("");
  const [brands, setBrands] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState("");
  const { whatsApps } = useWhatsApps();
  const [totalContactsCount, setTotalContactsCount] = useState(0);
  const [sortBy, setSortBy] = useState("name");
  const [sortOrder, setSortOrder] = useState("ASC");
  const [tabValue, setTabValue] = useState("contacts");
  const tabValueRef = useRef(tabValue);
  useEffect(() => {
    tabValueRef.current = tabValue;
  }, [tabValue]);
  const [summaryCounts, setSummaryCounts] = useState({ all: 0, contacts: 0, groups: 0 });

  // Estados para seleção múltipla
  const [selectedContacts, setSelectedContacts] = useState(new Set());
  const [selectAllMode, setSelectAllMode] = useState(false); // true = todos da empresa, false = apenas da página

  const [importContactModalOpen, setImportContactModalOpen] = useState(false);
  const [deletingContact, setDeletingContact] = useState(null);
  const [deletingAllContacts, setDeletingAllContacts] = useState(false);
  const [blockingContact, setBlockingContact] = useState(null);
  const [createGroupCampaignModalOpen, setCreateGroupCampaignModalOpen] = useState(false);
  const [selectedGroupForCampaign, setSelectedGroupForCampaign] = useState(null);
  const [unBlockingContact, setUnBlockingContact] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [exportContact, setExportContact] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [contactTicket, setContactTicket] = useState({});

  // Estados para exclusão múltipla com confirmação tipada
  const [deleteConfirmModalOpen, setDeleteConfirmModalOpen] = useState(false);
  const [deleteType, setDeleteType] = useState(''); // 'selected' ou 'all'

  const fileUploadRef = useRef(null);
  const [selectedTags, setSelectedTags] = useState([]);
  const { setCurrentTicket } = useContext(TicketsContext);

  // Estados para o modal de imagem
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const [selectedContactName, setSelectedContactName] = useState('');

  const { getAll: getAllSettings } = useCompanySettings();
  const [hideNum, setHideNum] = useState(false);
  const [enableLGPD, setEnableLGPD] = useState(false);


  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const { data } = await api.get('/brands');
        setBrands(data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchBrands();
  }, []);

  useEffect(() => {
    async function fetchData() {
      const settingList = await getAllSettings(user.companyId);

      for (const [key, value] of Object.entries(settingList)) {
        if (key === "enableLGPD") setEnableLGPD(value === "enabled");
        if (key === "lgpdHideNumber") setHideNum(value === "enabled");
      }
    }
    fetchData();
  }, []);

  // Funções para seleção múltipla CORRIGIDAS
  const handleSelectContact = (contactId) => {
    const newSelected = new Set(selectedContacts);
    if (newSelected.has(contactId)) {
      newSelected.delete(contactId);
    } else {
      newSelected.add(contactId);
    }
    setSelectedContacts(newSelected);
    setSelectAllMode(false); // Desativa modo "todos da empresa" quando seleciona individualmente
  };

  const handleSelectAllContacts = () => {
    if (selectAllMode) {
      // Se já está em modo "todos", desmarcar tudo
      setSelectedContacts(new Set());
      setSelectAllMode(false);
    } else {
      // Verificar se todos da página atual estão selecionados
      const currentPageIds = contacts.map(contact => contact.id);
      const allCurrentSelected = currentPageIds.every(id => selectedContacts.has(id));

      if (allCurrentSelected && selectedContacts.size === currentPageIds.length) {
        // Se todos da página estão selecionados, ativar modo "todos da empresa"
        setSelectAllMode(true);
        setSelectedContacts(new Set()); // Limpar seleção individual
      } else {
        // Selecionar todos da página atual
        setSelectedContacts(new Set(currentPageIds));
        setSelectAllMode(false);
      }
    }
  };

  // Limpar seleção quando contatos mudam
  useEffect(() => {
    setSelectedContacts(new Set());
    setSelectAllMode(false);
  }, [searchParam, selectedTags, selectedKanbanTags, selectedKanbanLane]);

  // Função para obter contagem correta
  const getSelectedCount = () => {
    if (selectAllMode) {
      return totalContactsCount;
    }
    return selectedContacts.size;
  };

  // Função para obter texto do botão
  const getSelectionButtonText = () => {
    if (selectAllMode) {
      return i18n.t("contacts.buttons.deleteAllCount", { count: totalContactsCount });
    }
    if (selectedContacts.size > 0) {
      return i18n.t("contacts.buttons.deleteSelected", { count: selectedContacts.size });
    }
    return i18n.t("contacts.buttons.deleteAll");
  };

  // Funções para exclusão múltipla CORRIGIDAS
  const handleBulkDeleteClick = () => {
    if (selectAllMode) {
      setDeleteType('all');
    } else if (selectedContacts.size > 0) {
      setDeleteType('selected');
    } else {
      toast.warning(i18n.t("contacts.validations.selectAtLeastOne"));
      return;
    }
    setDeleteConfirmModalOpen(true);
  };

  const handleBulkDeleteConfirm = async () => {
    try {
      if (deleteType === 'all') {
        await api.delete("/contacts/all", {
          data: {
            confirmation: "DELETE_ALL_CONTACTS",
            excludeIds: []
          }
        });
        toast.success(i18n.t("contacts.toasts.deletedAll", { count: totalContactsCount }));
      } else {
        const contactIds = Array.from(selectedContacts);
        await api.post("/contacts/bulk-delete", { contactIds });
        toast.success(i18n.t("contacts.toasts.deletedCount", { count: contactIds.length }));
      }

      // Resetar seleções
      setSelectedContacts(new Set());
      setSelectAllMode(false);

      // Atualizar lista
      setSearchParam("");
      setPageNumber(1);

    } catch (err) {
      toastError(err);
    } finally {
      setDeleteConfirmModalOpen(false);
      setDeleteType('');
    }
  };

  // Função para abrir modal da imagem
  const handleOpenImageModal = (imageUrl, contactName) => {
    setSelectedImage(imageUrl);
    setSelectedContactName(contactName);
    setImageModalOpen(true);
  };

  // Função para fechar modal da imagem
  const handleCloseImageModal = () => {
    setImageModalOpen(false);
    setSelectedImage('');
    setSelectedContactName('');
  };

  const handleImportExcel = async () => {
    try {
      const formData = new FormData();
      formData.append("file", fileUploadRef.current.files[0]);
      await api.request({
        url: `/contacts/upload`,
        method: "POST",
        data: formData,
      });
      history.go(0);
    } catch (err) {
      toastError(err);
    }
  };

  const handleExtractGroupContacts = async (contact) => {
    try {
      toast.info(i18n.t("contacts.toasts.extracting", "Extrayendo contactos..."));
      const { data } = await api.get(`/contacts/${contact.id}/participants`);
      if (!data || data.length === 0) {
        toast.error(i18n.t("contacts.toasts.noParticipants", "No se encontraron participantes"));
        return;
      }
      let csvContent = "Nombre,Numero,Es Administrador\n";
      data.forEach(participant => {
        csvContent += "\"" + (participant.name || "") + "\",\"" + (participant.number || "") + "\",\"" + (participant.isAdmin ? "Si" : "No") + "\"\n";
      });
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Grupo_${contact.name.replace(/[^a-z0-9]/gi, "_")}_Participantes.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.success(i18n.t("contacts.toasts.extractSuccess", "Contactos extraídos con éxito"));
    } catch (err) {
      toastError(err);
    }
  };

  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);
  }, [searchParam, selectedTags, selectedKanbanTags, selectedKanbanBoard, selectedKanbanLane, sortBy, sortOrder, tabValue]);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchContacts = async () => {
        try {
          const { data } = await api.get("/contacts/", {
            params: {
              searchParam,
              pageNumber,
              contactTag: JSON.stringify([...selectedTags, ...selectedKanbanTags]),
              kanbanLaneId: selectedKanbanLane,
              kanbanBoardId: selectedKanbanBoard,
              whatsappId: selectedWhatsapp,
              brandId: selectedBrand,
              sortBy,
              sortOrder,
              isGroup: tabValue === "all" ? "" : tabValue === "groups" ? "true" : "false",
            },
          });
          dispatch({ type: "LOAD_CONTACTS", payload: data.contacts });
          setHasMore(data.hasMore);
          setTotalContactsCount(data.count); // Armazenar contagem total
          if (data.totalAll !== undefined) setSummaryCounts({ all: data.totalAll, contacts: data.totalContacts, groups: data.totalGroups });
          setLoading(false);
        } catch (err) {
          toastError(err);
        }
      };
      fetchContacts();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchParam, pageNumber, selectedTags, selectedKanbanTags, selectedKanbanBoard, selectedKanbanLane, sortBy, sortOrder, tabValue, selectedWhatsapp, selectedBrand]);

  useEffect(() => {
    const companyId = user.companyId;

    const onContactEvent = (data) => {
      if (data.action === "update" || data.action === "create") {
        dispatch({
          type: "UPDATE_CONTACTS",
          payload: {
            contact: data.contact,
            currentTab: tabValueRef.current,
          },
        });
      }

      if (data.action === "delete") {
        dispatch({ type: "DELETE_CONTACT", payload: +data.contactId });
        setTotalContactsCount(prev => Math.max(0, prev - 1));

        setSelectedContacts(prevSelected => {
          const newSelected = new Set(prevSelected);
          if (newSelected.has(+data.contactId)) {
            newSelected.delete(+data.contactId);
            return newSelected;
          }
          return prevSelected;
        });
      }

      if (data.action === "bulk-delete") {
        dispatch({ type: "BULK_DELETE_CONTACTS", payload: data.contactIds });
        setTotalContactsCount(prev => Math.max(0, prev - data.contactIds.length));

        setSelectedContacts(prevSelected => {
          const newSelected = new Set(prevSelected);
          data.contactIds.forEach(id => newSelected.delete(+id));
          return newSelected;
        });
      }

      if (data.action === "delete-all") {
        dispatch({ type: "DELETE_ALL_CONTACTS", payload: { excludeIds: data.excludeIds } });
        setTotalContactsCount(data.excludeIds.length);

        setSelectedContacts(new Set());
        setSelectAllMode(false);
      }

      if (data.action === "syncComplete") {
        toast.success(`Sincronización finalizada. Se actualizaron ${data.repairedCount} contactos.`);
        setSearchParam(prev => prev); // Trigger a re-render/fetch if needed, or rely on UPDATE_CONTACTS sent previously
      }
    };

    socket.on(`company-${companyId}-contact`, onContactEvent);

    return () => {
      socket.off(`company-${companyId}-contact`, onContactEvent);
    };
  }, [socket]);

  const handleSelectTicket = (ticket) => {
    const code = uuidv4();
    const { id, uuid } = ticket;
    setCurrentTicket({ id, uuid, code });
  };

  const handleCloseOrOpenTicket = (ticket) => {
    setNewTicketModalOpen(false);
    if (ticket !== undefined && ticket.uuid !== undefined) {
      handleSelectTicket(ticket);
      history.push(`/tickets/${ticket.uuid}`);
    }
  };

  const handleSelectedTags = (selecteds) => {
    const tags = selecteds.map((t) => t.id);
    setSelectedTags(tags);
  };

  const handleSelectedKanbanTags = (kanbanData) => {
    setSelectedKanbanBoard(kanbanData.boardId || "");
    const boardWaIds = kanbanData.boardWhatsappIds || [];
    setSelectedBoardWhatsappIds(boardWaIds);
    // Si la conexión elegida no pertenece al nuevo embudo, volver a "Todas"
    if (kanbanData.boardId && selectedWhatsapp && !boardWaIds.includes(selectedWhatsapp)) {
      setSelectedWhatsapp("");
    }
    setSelectedKanbanLane(kanbanData.laneId || "");
    setSelectedKanbanTags(kanbanData.tags || []);
  };

  const handleSort = (property) => {
    const isAsc = sortBy === property && sortOrder === 'ASC';
    setSortOrder(isAsc ? 'DESC' : 'ASC');
    setSortBy(property);
  };

  const handleSearch = (event) => {
    setSearchParam(event.target.value.toLowerCase());
  };

  const handleOpenContactModal = () => {
    setSelectedContactId(null);
    setContactModalOpen(true);
  };

  const handleCloseContactModal = () => {
    setSelectedContactId(null);
    setContactModalOpen(false);
  };

  const hadleEditContact = (contactId) => {
    setSelectedContactId(contactId);
    setContactModalOpen(true);
  };

  
  const handleDeleteAllContacts = async () => {
    try {
      await api.delete("/contacts/all", { data: { confirmation: "DELETE_ALL_CONTACTS" } });
      toast.success("Todos los contactos han sido eliminados.");
      dispatch({ type: "RESET" });
      setPageNumber(1);
      window.location.reload();
    } catch (err) {
      toastError(err);
    }
    setDeletingAllContacts(false);
  };

  const handleDeleteContact = async (contactId) => {
    try {
      await api.delete(`/contacts/${contactId}`);
      toast.success(i18n.t("contacts.toasts.deleted"));
    } catch (err) {
      toastError(err);
    }
    setDeletingContact(null);
    setSearchParam("");
    setPageNumber(1);
  };

  const handleBlockContact = async (contactId) => {
    try {
      await api.put(`/contacts/block/${contactId}`, { active: false });
      toast.success(i18n.t("contacts.toasts.blocked"));
    } catch (err) {
      toastError(err);
    }
    setDeletingContact(null);
    setSearchParam("");
    setPageNumber(1);
    setBlockingContact(null);
  };

  const handleUnBlockContact = async (contactId) => {
    try {
      await api.put(`/contacts/block/${contactId}`, { active: true });
      toast.success(i18n.t("contacts.toasts.unblocked"));
    } catch (err) {
      toastError(err);
    }
    setDeletingContact(null);
    setSearchParam("");
    setPageNumber(1);
    setUnBlockingContact(null);
  };






  const loadMore = () => {
    setPageNumber((prevState) => prevState + 1);
  };

  const handleScroll = (e) => {
    if (!hasMore || loading) return;
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - (scrollTop + 100) < clientHeight) {
      loadMore();
    }
  };

  // Determinar qual ação de confirmação executar para modais simples
  const getConfirmAction = () => {
    if (deletingAllContacts) return handleDeleteAllContacts;
    if (deletingContact) return () => handleDeleteContact(deletingContact.id);
    if (blockingContact) return () => handleBlockContact(blockingContact.id);
    if (unBlockingContact) return () => handleUnBlockContact(unBlockingContact.id);
    return handleImportExcel;
  };

  // Determinar título do modal de confirmação simples
  const getConfirmTitle = () => {
    if (deletingAllContacts) return "¿Estás seguro de que deseas eliminar TODOS los contactos?";
    if (deletingContact) return `${i18n.t("contacts.confirmationModal.deleteTitle")} ${deletingContact.name}?`;
    if (blockingContact) return `${i18n.t("contacts.confirmationModal.blockTitle")} ${blockingContact.name}?`;
    if (unBlockingContact) return `${i18n.t("contacts.confirmationModal.unblockTitle")} ${unBlockingContact.name}?`;
    return i18n.t("contactListItems.confirmationModal.importTitlte");
  };

  // Determinar mensagem do modal de confirmação simples
  const getConfirmMessage = () => {
    if (exportContact) return i18n.t("contacts.confirmationModal.exportContact");
    if (deletingAllContacts) return "¡ATENCIÓN! Esta acción eliminará permanentemente TODOS tus contactos. ¿Deseas continuar?";
    if (deletingContact) return i18n.t("contacts.confirmationModal.deleteMessage");
    if (blockingContact) return i18n.t("contacts.confirmationModal.blockContact");
    if (unBlockingContact) return i18n.t("contacts.confirmationModal.unblockContact");
    return i18n.t("contactListItems.confirmationModal.importMessage");
  };

  const selectedCount = getSelectedCount();
  const isAnyContactSelected = selectAllMode || selectedContacts.size > 0;

  // Status do checkbox "selecionar todos"
  const selectAllCheckboxStatus = () => {
    if (selectAllMode) return { checked: true, indeterminate: false };

    const currentPageIds = contacts.map(contact => contact.id);
    const selectedInCurrentPage = currentPageIds.filter(id => selectedContacts.has(id)).length;

    if (selectedInCurrentPage === 0) {
      return { checked: false, indeterminate: false };
    } else if (selectedInCurrentPage === currentPageIds.length) {
      return { checked: true, indeterminate: false };
    } else {
      return { checked: false, indeterminate: true };
    }
  };

  const checkboxStatus = selectAllCheckboxStatus();


  return (
    <MainContainer className={classes.mainContainer}>
      <NewTicketModal
        modalOpen={newTicketModalOpen}
        initialContact={contactTicket}
        onClose={(ticket) => {
          handleCloseOrOpenTicket(ticket);
        }}
      />
      <ContactModal
        open={contactModalOpen}
        onClose={handleCloseContactModal}
        aria-labelledby="form-dialog-title"
        contactId={selectedContactId}
      ></ContactModal>

      {/* Modal de confirmação tipada para exclusão */}
      <ContactDeleteConfirmModal
        open={deleteConfirmModalOpen}
        onClose={() => setDeleteConfirmModalOpen(false)}
        onConfirm={handleBulkDeleteConfirm}
        deleteType={deleteType}
        selectedCount={selectedContacts.size}
        totalCount={totalContactsCount}
      />

      {/* Modal para visualizar imagem de perfil */}
      <Dialog
        open={imageModalOpen}
        onClose={handleCloseImageModal}
        className={classes.imageDialog}
        maxWidth="md"
      >
        <DialogTitle className={classes.dialogTitle}>
          <span>{i18n.t("contacts.imageModal.title", { name: selectedContactName })}</span>
          <IconButton onClick={handleCloseImageModal} size="small">
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {selectedImage ? (
            <img
              src={selectedImage}
              alt={i18n.t("contacts.imageModal.alt", { name: selectedContactName })}
              className={classes.profileImage}
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
          ) : (
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '200px',
              color: '#666'
            }}>
              {i18n.t("contacts.imageModal.unavailable")}
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Modal de confirmação simples para outras ações */}
      <ConfirmationModal
        title={getConfirmTitle()}
        open={confirmOpen}
        onClose={() => { setConfirmOpen(false); setDeletingAllContacts(false); }}
        onConfirm={getConfirmAction()}
      >
        {getConfirmMessage()}
      </ConfirmationModal>




      <Paper
        className={classes.mainPaper}
        variant="outlined"
      >
        <MainHeader>
        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
          <PageHelpGuide
            helpData={CONTACTS_HELP_DATA}
            tooltipText="Guía y Ayuda de Contactos (Haz clic para ver)"
          />
          <Title>
          {i18n.t("contacts.title")}
          {isAnyContactSelected && (
            <span style={{ color: '#f50057', marginLeft: 8 }}>
              - {selectedCount} {i18n.t("contacts.selection.selected")} {selectAllMode && i18n.t("contacts.selection.all")}
            </span>
          )}
        </Title>
        </div>
        
        <MainHeaderButtonsWrapper>
          

          <TextField
            style={{ minWidth: 300 }}
            variant="outlined"
            size="small"
            placeholder={i18n.t("contacts.searchPlaceholder")}
            type="search"
            value={searchParam}
            onChange={handleSearch}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="secondary" />
                </InputAdornment>
              ),
            }}
          />

          {/* Botões de ação em lote */}
          {isAnyContactSelected && (
            <div className={classes.bulkActions}>
              <Tooltip title={selectAllMode ? i18n.t("contacts.tooltips.deleteAll") : i18n.t("contacts.tooltips.deleteSelected")}>
                <Button
                  className={classes.dangerButton}
                  startIcon={<DeleteOutlineIcon />}
                  onClick={handleBulkDeleteClick}
                >
                  {getSelectionButtonText()}
                </Button>
              </Tooltip>
            </div>
          )}


          <Button
            className={classes.actionOutlineBtn}
            onClick={() => {
              setImportContactModalOpen(true);
            }}
          >
            {i18n.t("contacts.menu.importexport")}
          </Button>

          
          <Button
            className={classes.dangerButton}
            onClick={() => { setDeletingAllContacts(true); setConfirmOpen(true); }}
          >
            Eliminar Todos
          </Button>

          <Button
            className={classes.applyButton}
            onClick={handleOpenContactModal}
          >
            {i18n.t("contacts.buttons.add")}
          </Button>
        </MainHeaderButtonsWrapper>
      </MainHeader>
      <Paper style={{ padding: '16px', margin: '0 16px 16px 16px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', background: isDarkMode ? 'rgba(255, 255, 255, 0.02)' : '#fff', border: isDarkMode ? '1px solid rgba(255,255,255,0.1)' : '1px solid rgba(0,0,0,0.1)' }} elevation={0}>
            <TextField
              select
              label="Marca"
              variant="outlined"
              size="small"
              value={selectedBrand}
              onChange={(e) => setSelectedBrand(e.target.value)}
            >
              <MenuItem value=""><em>Todas</em></MenuItem>
              {brands.map((b) => (
                <MenuItem key={b.id} value={b.id}>{b.name}</MenuItem>
              ))}
            </TextField>

            <TagsKanbanFilter onFiltered={handleSelectedKanbanTags} brandId={selectedBrand} />

            <TextField
              select
              label="Conexión"
              variant="outlined"
              size="small"
              value={selectedWhatsapp}
              onChange={(e) => setSelectedWhatsapp(e.target.value)}
            >
              <MenuItem value=""><em>Todas</em></MenuItem>
              {whatsApps.filter(w => (!selectedBrand || w.brandId === selectedBrand) && (!selectedKanbanBoard || selectedBoardWhatsappIds.includes(w.id))).map((w) => (
                <MenuItem key={w.id} value={w.id}>{w.name}</MenuItem>
              ))}
            </TextField>

            <TagsFilter onFiltered={handleSelectedTags} kanban={0} />
          </Paper>
      <div style={{ marginBottom: 10, display: "flex", justifyContent: "flex-start" }}>
        <StandardTabs
          value={tabValue}
          onChange={(e, newValue) => setTabValue(newValue)}
          items={[
            {
              value: "contacts",
              label: i18n.t("contacts.tabs.contacts"),
              badge: summaryCounts.contacts,
              icon: <PersonIcon style={{ color: "#00E676" }} />,
            },
            {
              value: "groups",
              label: i18n.t("contacts.tabs.groups"),
              badge: summaryCounts.groups,
              icon: <GroupIcon style={{ color: "#00E5FF" }} />,
            },
            {
              value: "all",
              label: i18n.t("contacts.tabs.all"),
              badge: summaryCounts.all,
              icon: <PeopleAltIcon style={{ color: "#FFD600" }} />,
            },
          ]}
        />
      </div>

      {importContactModalOpen && (
        <ContactImportWpModal
          isOpen={importContactModalOpen}
          handleClose={() => setImportContactModalOpen(false)}
          selectedTags={selectedTags}
          hideNum={hideNum}
          userProfile={user.profile}
        />
      )}

        <input
          style={{ display: "none" }}
          id="upload"
          name="file"
          type="file"
          accept=".xls,.xlsx"
          onChange={() => {
            setConfirmOpen(true);
          }}
          ref={fileUploadRef}
        />

        {/* Toolbar para ações em lote */}
        {isAnyContactSelected && (
          <Toolbar className={`${classes.toolbar} ${classes.toolbarHighlight}`}>
            <Typography className={classes.toolbarTitle} color="inherit" variant="subtitle1">
              {selectedCount} {i18n.t("contacts.selection.selected")} {selectAllMode && i18n.t("contacts.selection.all")}
            </Typography>
            <div className={classes.bulkActions}>
              <Tooltip title={i18n.t("contacts.tooltips.cancelSelection")}>
                <Button
                  size="small"
                  onClick={() => {
                    setSelectedContacts(new Set());
                    setSelectAllMode(false);
                  }}
                >
                  {i18n.t("contacts.buttons.cancel")}
                </Button>
              </Tooltip>
              <Tooltip title={selectAllMode ? i18n.t("contacts.tooltips.deleteAll") : i18n.t("contacts.tooltips.deleteSelected")}>
                <IconButton
                  color="inherit"
                  onClick={handleBulkDeleteClick}
                >
                  <DeleteOutlineIcon />
                </IconButton>
              </Tooltip>
            </div>
          </Toolbar>
        )}

        <TableContainer className={classes.scrollArea}>
          <Table style={{ width: "100%", tableLayout: "fixed" }} size="small" stickyHeader>
            <TableHead>
            <TableRow>
              <TableCell className={`${classes.tableHeader} ${classes.checkboxCell}`}>
                <Checkbox
                  indeterminate={checkboxStatus.indeterminate}
                  checked={checkboxStatus.checked}
                  onChange={handleSelectAllContacts}
                  disabled={contacts.length === 0}
                  inputProps={{ 'aria-label': i18n.t("contacts.aria.selectAll") }}
                />
              </TableCell>
              <TableCell className={`${classes.tableHeader} ${classes.idCell}`} style={{ cursor: "pointer" }} onClick={() => handleSort("id")}>
                ID {sortBy === 'id' && (sortOrder === 'ASC' ? '▲' : '▼')}
              </TableCell>
              <TableCell className={`${classes.tableHeader} ${classes.avatarCell}`} align="center">{i18n.t("contacts.table.photo")}</TableCell>
              <TableCell className={classes.tableHeader} style={{ cursor: "pointer", minWidth: 200 }} onClick={() => handleSort("name")}>
                {i18n.t("contacts.table.name")} {sortBy === 'name' && (sortOrder === 'ASC' ? '▲' : '▼')}
              </TableCell>
              <TableCell className={classes.tableHeader} align="center" style={{ cursor: "pointer", minWidth: 150 }} onClick={() => handleSort("number")}>
                {i18n.t("contacts.table.whatsapp")} {sortBy === 'number' && (sortOrder === 'ASC' ? '▲' : '▼')}
              </TableCell>
              <TableCell className={classes.tableHeader} align="center" style={{ cursor: "pointer", minWidth: 150 }} onClick={() => handleSort("email")}>
                {i18n.t("contacts.table.email")} {sortBy === 'email' && (sortOrder === 'ASC' ? '▲' : '▼')}
              </TableCell>
              <TableCell className={classes.tableHeader} align="center" style={{ cursor: "pointer", minWidth: 100 }} onClick={() => handleSort("active")}>
                {i18n.t("contacts.table.status")} {sortBy === 'active' && (sortOrder === 'ASC' ? '▲' : '▼')}
              </TableCell>
              <TableCell className={classes.tableHeader} align="center" style={{ minWidth: 150 }}>{i18n.t("contacts.table.wallet")}</TableCell>
              <TableCell className={classes.tableHeader} align="center" style={{ minWidth: 120 }}>{i18n.t("contacts.table.actions")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <>
              {contacts.map((contact) => {
                const isSelected = selectAllMode || selectedContacts.has(contact.id);

                return (
                  <TableRow
                    key={contact.id}
                    selected={isSelected}
                  >
                    <TableCell className={classes.checkboxCell}>
                      <Checkbox
                        checked={isSelected}
                        onChange={() => handleSelectContact(contact.id)}
                        disabled={selectAllMode}
                        inputProps={{ 'aria-label': i18n.t("contacts.aria.selectContact", { name: contact.name }) }}
                      />
                    </TableCell>
                    <TableCell className={classes.idCell}>{contact.id}</TableCell>
                    <TableCell className={classes.avatarCell} align="center">
                      <Avatar
                        src={`${contact?.urlPicture}`}
                        className={classes.clickableAvatar}
                        onClick={() => handleOpenImageModal(contact?.urlPicture, contact.name)}
                      />
                    </TableCell>
                    <TableCell style={{ height: '100%', minHeight: '52px' }}>
                      {contact.name}
                    </TableCell>
                    <TableCell align="center">
                      {enableLGPD && hideNum && user.profile === "user"
                        ? contact.isGroup
                          ? contact.number
                          : formatSerializedId(contact?.number) === null
                            ? contact.number.slice(0, -6) +
                            "**-**" +
                            contact?.number.slice(-2)
                            : formatSerializedId(contact?.number)?.slice(0, -6) +
                            "**-**" +
                            contact?.number?.slice(-2)
                        : contact.isGroup
                          ? contact.number
                          : formatSerializedId(contact?.number)}
                    </TableCell>
                    <TableCell align="center">{contact.email}</TableCell>
                    <TableCell align="center">
                      {contact.active ? (
                        <CheckCircleIcon
                          style={{ color: "green" }}
                          fontSize="small"
                        />
                      ) : (
                        <CancelIcon style={{ color: "red" }} fontSize="small" />
                      )}
                    </TableCell>
                    <TableCell align="center">
                      {contact.contactWallets && contact.contactWallets.length > 0
                        ? contact.contactWallets[0].wallet?.name || i18n.t("contacts.table.userNotFound")
                        : i18n.t("contacts.table.notAssigned")}
                    </TableCell>
                    <TableCell align="center">
                      <IconButton
                        size="small"
                        disabled={!contact.active}
                        onClick={() => {
                          setContactTicket(contact);
                          setNewTicketModalOpen(true);
                        }}
                      >
                        {contact.channel ? (
                          <ConnectionIcon connectionType={contact.channel} />
                        ) : (
                          <WhatsApp style={{ color: "green" }} />
                        )}
                      </IconButton>

                      {contact.isGroup && (
                        <>
                          <Tooltip title={i18n.t("contacts.buttons.extractContacts") || "Extraer Contactos"}>
                            <IconButton
                              size="small"
                              className={`${classes.actionButton}`}
                              onClick={() => handleExtractGroupContacts(contact)}
                            >
                              <GetApp style={{ color: "#00b0ff" }} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title={i18n.t("contacts.buttons.createCampaign") || "Crear Campa�a Directa"}>
                            <IconButton
                              size="small"
                              className={`${classes.actionButton}`}
                              onClick={() => {
                                setSelectedGroupForCampaign(contact);
                                setCreateGroupCampaignModalOpen(true);
                              }}
                            >
                              <SendIcon style={{ color: "#f50057" }} />
                            </IconButton>
                          </Tooltip>
                        </>
                      )}
                      <Tooltip title={i18n.t("common.edit")}>
                        <IconButton
                          size="small"
                          className={`${classes.actionButton} ${classes.btnEdit}`}
                          onClick={() => hadleEditContact(contact.id)}
                        >
                          <EditIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title={contact.active ? i18n.t("contacts.confirmationModal.blockTitle") : i18n.t("contacts.confirmationModal.unblockTitle")}>
                        <IconButton
                          size="small"
                          className={contact.active ? `${classes.actionButton} ${classes.btnBlock}` : `${classes.actionButton} ${classes.btnCheck}`}
                          onClick={
                            contact.active
                              ? () => {
                                setConfirmOpen(true);
                                setBlockingContact(contact);
                              }
                              : () => {
                                setConfirmOpen(true);
                                setUnBlockingContact(contact);
                              }
                          }
                        >
                          {contact.active ? (
                            <BlockIcon />
                          ) : (
                            <CheckCircleIcon />
                          )}
                        </IconButton>
                      </Tooltip>
                      <Can
                        role={user.profile}
                        perform="contacts-page:deleteContact"
                        yes={() => (
                          <Tooltip title={i18n.t("common.delete")}>
                            <IconButton
                              size="small"
                              className={`${classes.actionButton} ${classes.btnDelete}`}
                              onClick={(e) => {
                                setConfirmOpen(true);
                                setDeletingContact(contact);
                              }}
                            >
                              <DeleteOutlineIcon />
                            </IconButton>
                          </Tooltip>
                        )}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
              {loading && <TableRowSkeleton columns={9} />}
            </>
          </TableBody>
        </Table>
        
        </TableContainer>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px' }}>
          <span style={{ color: '#fff', fontSize: '1rem', fontWeight: 'bold', paddingLeft: '15px' }}>
            Mostrando {totalContactsCount > 0 ? ((pageNumber - 1) * 100) + 1 : 0} - {((pageNumber - 1) * 100) + contacts.length} de {totalContactsCount}
          </span>
          <div>
            <Button 
              disabled={pageNumber === 1} 
              onClick={() => setPageNumber(prev => prev - 1)}
            >
              Anterior
            </Button>
            <span style={{ padding: '8px 15px', color: '#fff', fontWeight: 'bold' }}>Página {pageNumber}</span>
            <Button 
              disabled={!hasMore} 
              onClick={() => setPageNumber(prev => prev + 1)}
            >
              Siguiente
            </Button>
          </div>
        </div>

      </Paper>
      {createGroupCampaignModalOpen && (
        <CreateGroupCampaignModal
          open={createGroupCampaignModalOpen}
          onClose={() => setCreateGroupCampaignModalOpen(false)}
          groupContact={selectedGroupForCampaign}
        />
      )}
    </MainContainer>
  );
};

export default Contacts;
